import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/Kebab/Kebab.styl'

type KebabProps = {
  expanded?: boolean
  hamburgerMode?: boolean
}

export const Kebab: FC<KebabProps> = (props) => {
  const { expanded, hamburgerMode } = props

  const classes = cn(styles.kebab, {
    [styles.expanded]: expanded,
    [styles.hamburgerMode]: hamburgerMode,
  })

  return (
    <div className={ classes }>
      <div className={ cn(styles.item, styles.member) } />
      <div className={ cn(styles.item, styles.peers) } />
      <div className={ cn(styles.item, styles.others) } />
    </div>
  )
}

